import React, { Component } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';

import FilterBarViews from './views';
import { activateFilterPanel } from 'PipeRouter';


class FilterBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentParentIndex: 0
    };
  }

  goToNextMenu = (currentParent, nextParentIndex) => {
    const menus = currentParent.parentElement.getElementsByClassName('menu');

    if (nextParentIndex === menus.length) {
      nextParentIndex = 0;
      return;
    } else if (nextParentIndex < 0) {
      nextParentIndex = menus.length - 1;
    }

    menus[nextParentIndex].focus();
    this.setState({ currentParentIndex: nextParentIndex });
  }

  goToNextMenuFromSubmenu = (currentParent, nextParentIndex) => {
    const menuList = currentParent.parentElement.getElementsByClassName('menu');
    const mLen = menuList.length;

    if (nextParentIndex === mLen) {
      menuList[mLen - 1].focus();
      return;
    }

    if (nextParentIndex < 0) {
      menuList[0].focus();
      return;
    }

    menuList[nextParentIndex].focus();
    this.setState({ currentParentIndex: nextParentIndex });
    event.preventDefault();
  }

  openFilterPanel = () => {
    this.props.activateFilterPanel();
  }

  updateParentIndex = val => {
    this.setState({ currentParentIndex: val });
  }

  render() {
    const { isMobile, openFilter } = this.props;
    const { currentParentIndex } = this.state;

    const viewProps = {
      isMobile,
      currentParentIndex,
      openFilterPanel: this.openFilterPanel,
      goToNextMenuFromSubmenu: this.goToNextMenuFromSubmenu,
      goToNextMenu: this.goToNextMenu,
      updateParentIndex: this.updateParentIndex
    };

    return <FilterBarViews { ...viewProps } />;
  }
}

FilterBar.propTypes = {
  isMobile: bool.isRequired
};

function mapStateToProp(state) {
  const { reader:{ isMobile }} = state;

  return {
    isMobile
  };
}

export default connect(mapStateToProp, {
  activateFilterPanel
})(FilterBar);
